import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AuthModule } from './auth/auth.module';

import { FallbackModule } from './fallback/fallback.module';
import { GlobalModule } from './global/global.module';
import { LayoutModule } from './layout/layout.module';
import { MaintenanceModule } from './maintenance/maintenance.module';
import { CoreStoreModule } from './store/store.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AuthModule,
    FallbackModule,
    MaintenanceModule,
    GlobalModule,
    CoreStoreModule,
    LayoutModule,
  ],
  exports: [LayoutModule],
})
export class LibCoreModule {}
